import { registerWebserverToken } from '../shared/xomics-webserver-client';

const COOKIE_NAME = 'gpolygenesis-cookie';

function parseCookies() {
  return Object.fromEntries(document.cookie.split(';').map(c => {
    const [k, ...v] = c.trim().split('=');
    return [k, v.join('=')];
  }));
}

function setCookie(id, expiryMs) {
  const value = `${id}|${expiryMs}`;
  document.cookie = `${COOKIE_NAME}=${value}; path=/; expires=${new Date(expiryMs).toUTCString()}; samesite=strict`;
}

async function notifyBackend(id) {
  if (!id) return;
  await registerWebserverToken(id);
}

function getCookie() {
  const all = parseCookies();
  const val = all[COOKIE_NAME];
  if (val) {
    const [id, expiry] = val.split('|');
    return { id, expiry: parseInt(expiry, 10) };
  }
  return null;
}

export async function ensureGPolygenesisCookie() {
  const cookie = getCookie();
  if (cookie) {
    await notifyBackend(cookie.id);
    return cookie;
  }
  const id = crypto.randomUUID();
  const expiry = Date.now() + 180 * 24 * 60 * 60 * 1000;
  setCookie(id, expiry);
  await notifyBackend(id);
  return { id, expiry };
}

export function getCookieDaysLeft() {
  const cookie = getCookie();
  if (!cookie) {
    return 0;
  }
  const diff = cookie.expiry - Date.now();
  return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)));
}

export function getCookieId() {
  const cookie = getCookie();
  return cookie ? cookie.id : null;
}
